import { defineMessages } from 'react-intl';

export default defineMessages({
  account: {
    id: 'PayAsYouGo.account',
    defaultMessage: 'Pay-As-You-Go Account',
  },
  active: {
    id: 'PayAsYouGo.active',
    defaultMessage: 'Active',
  },
  blocked: {
    id: 'PayAsYouGo.blocked',
    defaultMessage: 'Blocked',
  },
  blockAccount: {
    id: 'PayAsYouGo.blockAccount',
    defaultMessage: 'Block Account',
  },
  unblockAccount: {
    id: 'PayAsYouGo.unblockAccount',
    defaultMessage: 'Unblock Account',
  },
  emailDispute: {
    id: 'PayAsYouGo.emailDispute',
    defaultMessage: 'Email dispute instructions',
  },
  buttonBlock: {
    id: 'PayAsYouGo.buttonBlock',
    defaultMessage: 'Block',
  },
  buttonUnblock: {
    id: 'PayAsYouGo.buttonUnblock',
    defaultMessage: 'Unblock',
  },
  buttonCancel: {
    id: 'PayAsYouGo.buttonCancel',
    defaultMessage: 'Cancel',
  },
  blockAccountTitle: {
    id: 'PayAsYouGo.blockAccountTitle',
    defaultMessage: 'Reason to block',
  },
  unblockAccountTitle: {
    id: 'PayAsYouGo.unblockAccountTitle',
    defaultMessage: 'Unblock this account?',
  },
  dropdownLabel: {
    id: 'PayAsYouGo.dropdownLabel',
    defaultMessage: 'Select reason',
  },
  paymentFailed: {
    id: 'PayAsYouGo.paymentFailed',
    defaultMessage: 'Failed Payment',
  },
  fraudThresholdExceeded: {
    id: 'PayAsYouGo.fraudThresholdExceeded',
    defaultMessage: 'Fraudulent Activity',
  },
  blockedReason: {
    id: 'PayAsYouGo.blockedReason',
    defaultMessage: 'Blocked Reason',
  },
  unblockAccountMessage: {
    id: 'PayAsYouGo.unblockAccountMessage',
    defaultMessage: 'Are you sure you want to unblock this account?',
  },
});
